import AccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import { EmtTypography } from "./EmtTypography";
import { EmtIcon } from "./EmtIcon";

export type EmtAccordionSummaryProps = AccordionSummaryProps & {
  /**
   * Title of the accordion
   */
  title: string;
  nonce?: string;
};

export function EmtAccordionSummary(props: EmtAccordionSummaryProps) {
  const { title, ...rest } = props;
  return (
    <AccordionSummary
      expandIcon={<EmtIcon className="emt-right-1" sx={{ color: "black" }} />}
      {...rest}
    >
      <EmtTypography variant="body1" fontWeight="bold" fontSize="18px">
        {title}
      </EmtTypography>
    </AccordionSummary>
  );
}
